import { ENABLE_STABLESWAP } from 'config'

export const getProtocol = () => {
  if (ENABLE_STABLESWAP && window.location.href.includes('stable')) return 'stable'
  if (window.location.href.includes('v2')) return 'v2'
  return 'v1'
}
